import { IAction } from "../utils";
import { reducerTypes } from "./types";

export const INITIAL: boolean = false;

export const adminReducer = (state = INITIAL, { type }: IAction) => {
  switch (type) {
    case reducerTypes.TOGGLE_ADMIN:
      return !state;
    default:
      return state;
  }
};
